import isEmpty from 'lodash/isEmpty';
import WidgetWrapper from '../../wrapper/WidgetWrapper';
import dom from '../../wrapper/DomWrapper';
import EmbedCode from './EmbedCode';

class EmbedWidgets extends WidgetWrapper {
  init = () => {
    this.elEmbedCollection = dom.getCollection(this.selector);

    if (isEmpty(this.elEmbedCollection)) return;

    this.elEmbedCollection.forEach((embedBlock) => {
      const embedWidget = new EmbedCode(embedBlock);
      embedWidget.init();
    });

    dom.on(dom.window, 'message', this.updateIframeHeight);
  };

  updateIframeHeight = (e) => {
    const { type, height, name } = e.data;
    const elIframe = dom.getElement(`iframe[name="${name}"]`);

    if (!elIframe) return;

    const parent = elIframe.parentNode;

    if (type === 'iframeResize') {
      dom.removeClass(parent, 'show_spinner');
      elIframe.setAttribute('height', height);
    }
  };
}

export default EmbedWidgets;
